/* Rore Active — collection.js (vanilla JS, no jQuery) */

(function() {

  // ─── Infinite scroll ────────────────────────────────────────────────────────

  var currentObserver = null;

  function skeletonHTML(count) {
    var card = '<article class="product-card product-card--skeleton" aria-hidden="true">' +
      '<div class="product-card__media"><div class="product-card__skeleton-img"></div></div>' +
      '<div class="product-card__skeleton-swatches"><span></span><span></span><span></span><span></span></div>' +
      '<div class="product-card__skeleton-info">' +
        '<div class="product-card__skeleton-line" style="width:80px"></div>' +
        '<div class="product-card__skeleton-line" style="width:105px"></div>' +
        '<div class="product-card__skeleton-line" style="width:60px"></div>' +
        '<div class="product-card__skeleton-line" style="width:25px"></div>' +
      '</div>' +
      '</article>';
    var html = '';
    for (var i = 0; i < count; i++) html += card;
    return html;
  }

  function removeSkeletons(grid) {
    grid.querySelectorAll('.product-card--skeleton').forEach(function(el) { el.remove(); });
  }

  function initInfiniteScroll() {
    if (currentObserver) { currentObserver.disconnect(); currentObserver = null; }

    var trigger = document.querySelector('[data-js-load-more]');
    if (!trigger) return;

    var grid    = document.querySelector('.js-grid');
    var loading = false;

    currentObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || loading) return;

        var nextUrl    = trigger.dataset.nextLink;
        var totalPages = parseInt(trigger.dataset.allPages, 10) || 1;
        var curPage    = parseInt(trigger.dataset.thisPage, 10) || 1;

        if (!nextUrl || curPage >= totalPages) { currentObserver.disconnect(); return; }

        loading = true;
        var perPage = parseInt(trigger.dataset.perPage, 10) || 4;
        if (grid) grid.insertAdjacentHTML('beforeend', skeletonHTML(perPage));

        fetch(nextUrl)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser  = new DOMParser();
            var doc     = parser.parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('.js-grid');

            if (newGrid && grid) {
              removeSkeletons(grid);
              grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
              if (typeof loopSearchProductsByType === 'function') loopSearchProductsByType();
              if (typeof applyColorTitleCase === 'function') applyColorTitleCase();
            }

            var newTrigger = doc.querySelector('[data-js-load-more]');
            if (newTrigger) {
              trigger.dataset.nextLink = newTrigger.dataset.nextLink || '';
              trigger.dataset.thisPage = newTrigger.dataset.thisPage || curPage + 1;
            } else {
              trigger.dataset.nextLink = '';
            }

            loading = false;

            var nextPage = parseInt(trigger.dataset.thisPage, 10);
            if (!trigger.dataset.nextLink || nextPage >= totalPages) {
              currentObserver.disconnect();
            }
          })
          .catch(function(e) {
            console.error('Infinite scroll:', e);
            if (grid) removeSkeletons(grid);
            loading = false;
          });
      });
    }, { rootMargin: '0px 0px 400px 0px' });

    currentObserver.observe(trigger);
  }

  initInfiniteScroll();
  document.addEventListener('rore:filters:applied', initInfiniteScroll);


  // ─── Layout toggle (grid column switcher) ────────────────────────────────────

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-grid-cols]');
    if (!btn) return;
    var grid = document.querySelector('.js-grid');
    if (!grid) return;

    var cols = btn.dataset.gridCols;
    grid.className = grid.className.replace(/\bgrid--\dcol\b/g, '').trim();
    grid.classList.add('grid--' + cols + 'col');

    document.querySelectorAll('[data-grid-cols]').forEach(function(b) {
      b.classList.toggle('is-active', b.dataset.gridCols === cols);
    });

    try { localStorage.setItem('rore-grid-cols', cols); } catch(e) {}
  });

  // Restore saved grid preference
  try {
    var savedCols = localStorage.getItem('rore-grid-cols');
    var grid = document.querySelector('.js-grid');
    if (savedCols && grid) {
      grid.className = grid.className.replace(/\bgrid--\dcol\b/g, '').trim();
      grid.classList.add('grid--' + savedCols + 'col');
      document.querySelectorAll('[data-grid-cols]').forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.gridCols === savedCols);
      });
    }
  } catch(e) {}

})();
